import DevelopAccountScreen from './develop-account';

export default DevelopAccountScreen;
